// extracted by mini-css-extract-plugin
export default {"container":"Metadata-module__container--ydeM8","heading":"Metadata-module__heading--vvkcl"};